export default {
  setCountries(state, { items = [] }) {
    state.countries = items;
  },
  setCities(state, { items = [] }) {
    state.cities = items;
  },
  setCounties(state, { items = [] }) {
    state.counties = items;
  },
  setDistricts(state, { items = [] }) {
    state.districts = items;
  },
};
